<template>
  <ul v-if="events" class="mb-12">
    <li v-for="(day, count) in filteredEvents" class="flex align-top" :key="count">
      <div class="mr-6 inline-block tracking-wide leading-snug">
        <span :class="{'text-white': day.hide_date}">{{ formatDate(day.date) }}</span>
        <div class="uppercase text-red" v-if="today(day.date)">{{ lang === 'en' ? 'Today' : 'Auj' }}</div>
      </div>
      <ul class="inline-block">
        <li v-if="getDescription(day)" class="mb-3">
          <router-link v-if="!filter" class="inline-block" :to="getEventLink(day)"><BaseCircleDashed class="w-5 inline mr-3 mb-1" /><h4 class="inline" v-html="getDescription(day)" /></router-link>
          <span v-else>
            <BaseCircleDashed class="w-5 inline mr-3 mb-1" /><h4 class="inline" v-html="getDescription(day)" />
          </span>
        </li>
        <li v-for="(event, count) in filteredChildEvents(day)" class="pb-6 md:pr-6 leading-snug" :key="count">
          <router-link class="inline-block" :to="getEventLink(event)">
            <span class="tracking-wide">{{ event.time_start }} - {{ event.time_end }}</span><br/>
            {{ getFieldByLang(event, 'title', lang) }}
          </router-link><br/>
          <router-link :to="`/tag/${cat}`" class="pill hover:bg-black hover:text-white" v-for="(cat, count) in event.category" :key="count">
            {{ catName(cat) }}
          </router-link>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'
import { isToday } from 'date-fns'
export default {

  name: 'EventList',

  data () {
    return {

    }
  },
  props: ['prefix', 'events', 'filter', 'tag'],
  computed: {
    ...mapState(['lang', 'cats']),
    filteredEvents () {
      if (this.filter) {
        return this.events.filter(x => {
          return this.filteredChildEvents(x).length
        })
      } else {
        return this.events
      }
    }
  },
  methods: {
    getDescription (day) {
      return this.getFieldByLang(day, 'description', this.lang)
    },
    filteredChildEvents (day) {
      if (this.filter) {
        return day.events.filter(x => {
          return x.category.includes(this.tag)
        })
      } else {
        return day.events
      }
    },
    catName (cat) {
      if (this.lang === 'en') {
        return cat.replace(/_/g, ' ')
      } else {
        return this.cats[cat]
      }
    },
    today (date) {
      return isToday(new Date(date))
    },
    getEventLink (event) {
      if (this.$route.name === "tags") {
        return `/${this.prefix}/${this.tag}/${event.date}/${event.slug}`
      } else {
        return `/${this.prefix}/${event.date}/${event.slug}`
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  >>> .inline p
    @apply inline
  .text-red
    color: rgb(255,0,0)
  a.pill
    color: black

    &:hover
      color: white
</style>
